module.exports = __webpack_public_path__ + "media/images/lb/986-3ddd3eac1fb368bf70c726031ac8b287.svg";